import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ["section"]
  static values = {
    routineSlug: String
  }

  connect() {
    this.sectionTargets.forEach(section => {
      this.createRoutineSortable(section)
    })
  }

  createRoutineSortable(element) {
    const csrfToken = document.querySelector("[name='csrf-token']").content

    new Sortable(element, {
      handle: '.sort-handle',
      easing: "cubic-bezier(1, 0, 0, 1)",
      ghostClass: 'invisible',
      chosenClass: "!bg-warm-gray-200",
      animation: 150,
      delay: 150,
      delayOnTouchOnly: true,
      onEnd: (evt) => {
        const newOrder = {}
        const sortableItems = evt.to.getElementsByClassName('sortable-item')

        Array.from(sortableItems).forEach((el, index) => {
          const dataId = el.dataset.id

          if (evt.item.dataset.id == dataId) {
            newOrder[dataId] = index + 1
          }

          // Update displayed text for both owner and non-owner views
          // For non-owner views (has class 'step-id')
          const stepElements = el.querySelectorAll('.step-id')
          stepElements.forEach((obj) => {
            obj.textContent = index + 1
          })

          // For owner views (button with data-order span)
          const ownerStepElement = el.querySelector('span[data-order]')
          if (ownerStepElement) {
            // Only update if not logged (when showing order number, not checkmark)
            ownerStepElement.setAttribute('data-order', index + 1)
            if (ownerStepElement.textContent.trim() !== '' && !ownerStepElement.querySelector('svg')) {
              ownerStepElement.textContent = index + 1
            }
          }
        })

        const formData = new FormData()
        formData.append('routine_products', JSON.stringify(newOrder))

        fetch(`/routines/routine-products/${this.routineSlugValue}`, {
          method: "PATCH",
          headers: {
            "X-CSRF-Token": csrfToken
          },
          body: formData
        })
      }
    })
  }
}
